import React from "react";
import {
  Avatar,
  InputAdornment,
  Stack,
  TextField,
  Tooltip,
  Box,
  Typography,
  FormControl,
  InputLabel,
  Button,
  Link,
} from "@mui/material";
import DirectionsRunIcon from "@mui/icons-material/DirectionsRun";
import { Link as RouterLink } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import InfoIcon from "@mui/icons-material/Info";
import EditIcon from "@mui/icons-material/Edit";
import { s3baseUrl } from "src/config/config";
import {
  getMihr,
  getKmhr,
  getPaceText,
  getMihrForPace,
  getKmhrForPace,
  getPaceTextinPaces,
  formatWithLeadingZeros,
} from "src/utils/constant";
import { Icon } from "@iconify/react";
import CustomPopoverSection from "src/components/MenuOption/CustomPopoverSection";

const inputSx = {
  "& legend": { display: "none" },
  "& fieldset": { border: "none", top: 0 },
  fontSize: "13px",
  "& .MuiOutlinedInput-input": { padding: 0 },
};

const inputSx2 = {
  "& legend": { display: "none" },
  "& fieldset": { top: 0 },
  fontSize: "13px",
  border: "none",
  "& fieldset": { border: "none" },
  "& .MuiOutlinedInput-input": { padding: 0 },
};

const CustomFeilds = ({
  addArray,
  memueOptions1,
  index,
  exerIndex,
  exerData,
  handleArrowSuperSet,
  handleParametersSuperset,
  isWithHistoryAndBigScreen,
  isHistory,
  isSidebar,
  handleChangeEmomSet,
  handleChangeEmomSetTempo,
  handleChangeVdotDistance,
  handleChangeVdotPaceType,
  handleClickOpen,
  handleDeleteIntervalExercise,
  handleHistoryPreviousOpen,
  handleHistorySupersetOpen,
  handleMinutesChange,
  handleMinutesChangeSets,
  handleSupersetExerciseList,
  memberId,
  handleSecondsChangeSets,
  selectedExercise,
  handleSecondsChange,
  reps_for_time,
  member_vdot,
  setPaceModalOpen,
}) => {
  let class_name = isWithHistoryAndBigScreen
    ? "col-2 pe-0 py-2"
    : "col-12 col-md-2 col-lg-1 pe-0 py-2";

  let class_name_1 = isWithHistoryAndBigScreen
    ? "col-3 pe-0 py-2"
    : "col-12 col-md-3 col-lg-2 pe-0 py-2";

  return (
    <div className="ms-4 my-1">
      <div className="d-flex workout-set-card">
        <Box sx={{ position: "relative", width: "100%" }}>
          <div className="row">
            <div className="col-1 p-0 d-flex align-items-center justify-content-end order-1 order-md-3">
              <Tooltip title="Delete">
                <DeleteIcon
                  className={`${"del-icon-calendar-workout-working"}`}
                  onClick={() => handleDeleteIntervalExercise(index, exerIndex)}
                />
              </Tooltip>
              <CustomPopoverSection
                menu={memueOptions1(index, exerIndex)}
                data={{ index, exerIndex }}
              />
            </div>
            <div className="col-11 col-md-6 d-flex align-items-center p-0 mt-2 mt-md-0 order-2 order-md-2">
              <div className="exercise-label-box">
                <span className="outer-label">Exercise</span>
                <div className="d-flex align-items-center justify-content-between">
                  <div
                    className="exercise-label w-100"
                    onClick={() =>
                      handleSupersetExerciseList(
                        index,
                        exerIndex,
                        exerData?.exercise ? true : false,
                      )
                    }
                  >
                    <div className="d-flex align-items-center">
                      {exerData?.exercise?.image?.thumbnail_3 && (
                        <Avatar
                          sx={{ borderRadius: "5px" }}
                          alt="User Image"
                          src={
                            s3baseUrl + exerData?.exercise?.image?.thumbnail_3
                          }
                        />
                      )}
                      <div className="label-text ms-1">
                        {exerData?.exercise?.title
                          ? exerData?.exercise?.title
                          : ""}
                      </div>
                    </div>
                  </div>
                  <div className="exercise-action">
                    <div style={{ fontSize: "16px" }}>
                      {exerData?.exercise ? (
                        <div>
                          <InfoIcon
                            onClick={() =>
                              handleClickOpen(exerData?.exercise?._id)
                            }
                            className="d-block"
                            fontSize="14px"
                            sx={{ opacity: 0.5, cursor: "pointer" }}
                          />
                          <EditIcon
                            onClick={() =>
                              handleSupersetExerciseList(index, exerIndex, true)
                            }
                            fontSize="12px"
                            sx={{ opacity: 0.5, cursor: "pointer" }}
                          />
                        </div>
                      ) : (
                        <AddIcon
                          onClick={() =>
                            handleSupersetExerciseList(index, exerIndex)
                          }
                          sx={{ opacity: 0.5, cursor: "pointer" }}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <Button
                sx={{ textTransform: "inherit" }}
                size="small"
                color="primary"
                variant="contained"
                className="d-flex align-items-center ms-2 small-contained-dialog-button"
                onClick={() => {
                  handleArrowSuperSet(
                    !exerData?.open ? true : false,
                    index,
                    exerIndex,
                  );
                }}
              >
                {!exerData?.open ? (
                  <KeyboardArrowDownIcon
                    sx={{ cursor: "pointer", fontSize: "20px" }}
                  />
                ) : (
                  <KeyboardArrowUpIcon
                    sx={{ cursor: "pointer", fontSize: "20px" }}
                  />
                )}

                <Typography
                  variant="body2"
                  sx={{
                    whiteSpace: "nowrap",
                  }}
                >
                  {` Sets ${1}`}
                </Typography>
              </Button>
            </div>

            <div
              className={`col-sm-11 ${
                isHistory ? "col-md-5" : "col-md-5"
              } col-lg-5 p-0 mt-2 mt-md-0 mt-lg-0 order-2 order-md-2 d-flex align-items-center justify-content-start `}
            >
              <div className="d-flex align-items-center mx-1">
                <div
                  className="d-flex align-items-center ms-3 set-parameters "
                  onClick={() => {
                    handleParametersSuperset(index, exerIndex);
                  }}
                >
                  <Icon icon="pajamas:labels" fontSize="10px" />
                  <Typography variant="body2" sx={{ ml: 0.5 }}>
                    {`Parameters`}
                  </Typography>
                </div>
                {!isWithHistoryAndBigScreen &&
                isHistory &&
                exerData?.exercise ? (
                  <>
                    <Button
                      sx={{ textTransform: "inherit" }}
                      size="small"
                      color="primary"
                      variant="contained"
                      className="d-flex align-items-center ms-2 small-contained-dialog-button"
                      onClick={() => {
                        handleHistorySupersetOpen(exerData, index, exerIndex);
                      }}
                    >
                      <Icon icon="fa-solid:history" fontSize="10px" />
                      <Typography variant="body2" sx={{ ml: 0.5 }}>
                        {`History`}
                      </Typography>
                    </Button>
                    {member_vdot && setPaceModalOpen && (
                      <Button
                        sx={{ textTransform: "inherit" }}
                        size="small"
                        color="primary"
                        variant="contained"
                        className="d-flex align-items-center ms-2 small-contained-dialog-button"
                        onClick={() => setPaceModalOpen(true)}
                      >
                        <DirectionsRunIcon sx={{ fontSize: "14px" }} />
                        <Typography variant="body2" sx={{ ml: 0.5 }}>
                          Pace
                        </Typography>
                      </Button>
                    )}
                  </>
                ) : isWithHistoryAndBigScreen &&
                  exerData?.history &&
                  selectedExercise != exerData?.exercise?._id ? (
                  <Button
                    sx={{ textTransform: "inherit" }}
                    size="small"
                    color="primary"
                    variant="contained"
                    className="d-flex align-items-center ms-2 small-contained-dialog-button"
                    onClick={() => {
                      handleHistoryPreviousOpen(exerData);
                    }}
                  >
                    <Icon icon="fa-solid:history" fontSize="10px" />
                    <Typography variant="body2" sx={{ ml: 0.5 }}>
                      {`History`}
                    </Typography>
                  </Button>
                ) : (
                  isHistory &&
                  exerData?.history && (
                    <Button
                      sx={{ textTransform: "inherit" }}
                      size="small"
                      color="primary"
                      variant="outlined"
                    >
                      <Icon icon="fa-solid:history" fontSize="10px" />
                      <Typography variant="body2" sx={{ ml: 0.5 }}>
                        Viewing History
                      </Typography>
                    </Button>
                  )
                )}
              </div>
            </div>
          </div>
          {exerData?.open &&
            exerData?.set?.map((item, setIndex) => (
              <div className="d-flex align-items-center my-3 workout-card-inset">
                {memberId &&
                exerData.parameters.includes("Vdot") &&
                !item?.vdot ? (
                  <Stack
                    direction="row"
                    spacing={1}
                    alignItems="center"
                    justifyContent="start"
                    sx={{
                      padding: exerData.parameters.includes("Vdot")
                        ? "9px 0px"
                        : "",
                      overflowX: "auto",
                      "&::-webkit-scrollbar": {
                        height: "5px",
                      },
                      "&::-webkit-scrollbar-thumb": {
                        backgroundColor: "#888",
                        borderRadius: "5px",
                      },
                      "&::-webkit-scrollbar-track": {
                        backgroundColor: "#f1f1f1",
                      },
                    }}
                  >
                    <Typography
                      variant="subtitle2"
                      sx={{
                        opacity: 0.6,
                        fontWeight: "600",
                        fontSize: "12px",
                      }}
                    >
                      Auto Pacer is not calculated. Please{" "}
                      <Link
                        component={RouterLink}
                        variant="subtitle2"
                        to={`/member/edit-member/${memberId}`}
                      >
                        Click here
                      </Link>{" "}
                      to calculate it.
                    </Typography>
                  </Stack>
                ) : (
                  <div className="row w-100">
                    {exerData.parameters.includes("Vdot") && (
                      <>
                        {memberId && (
                          <div
                            className={
                              isWithHistoryAndBigScreen
                                ? "col-2 pe-0 py-1"
                                : `col-12 col-md-2 col-lg-1 pe-0 py-1`
                            }
                          >
                            <TextField
                              id="outlined-basic"
                              size="small"
                              variant="outlined"
                              placeholder="0"
                              type="number"
                              label="Auto Pacer"
                              value={item?.vdot}
                              name="vdot"
                              InputLabelProps={{
                                className: "textfiels-input-label",
                                shrink: true,
                                style: {
                                  fontSize: "14px",
                                },
                              }}
                              InputProps={{
                                className: "textfiels-input-value",
                                style: {
                                  fontSize: "13px",
                                  paddingLeft: "0px",
                                  paddingRight: "5px",
                                },
                                readOnly: true,
                              }}
                              sx={{
                                borderRadius: "5px",
                                fontSize: "13px",
                                width: "100%",
                                marginTop: "5px",
                              }}
                            />
                          </div>
                        )}
                        <div
                          className={
                            isWithHistoryAndBigScreen
                              ? "col-5 pe-0 py-1"
                              : `col-12 col-md-5 ${
                                  isSidebar ? "col-lg-4" : "col-lg-3"
                                } pe-0 py-1`
                          }
                        >
                          <TextField
                            id="outlined-basic"
                            variant="outlined"
                            label="Type"
                            InputLabelProps={{
                              className: "textfiels-input-label",
                              shrink: true,
                              style: {
                                fontSize: "14px",
                              },
                            }}
                            InputProps={{
                              className: "textfiels-input-value",
                              style: {
                                fontSize: "13px",
                                paddingLeft: "0px",
                                paddingRight: "0px",

                                justifyContent: "center",
                              },
                              endAdornment: (
                                <InputAdornment
                                  position="end"
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <Select
                                    id="select-option"
                                    variant="outlined"
                                    size="small"
                                    name="race_type"
                                    value={item?.race_type}
                                    label="Weight Type"
                                    inputProps={{
                                      style: {
                                        padding: 0,
                                      },
                                    }}
                                    onChange={(e) => {
                                      handleChangeVdotDistance(
                                        e,
                                        index,
                                        exerIndex,
                                        setIndex,
                                      );
                                    }}
                                    sx={inputSx2}
                                  >
                                    <MenuItem value="el">Easy/Long</MenuItem>
                                    <MenuItem value="c">Compromised</MenuItem>
                                    <MenuItem value="t">Threshold</MenuItem>
                                    <MenuItem value="i">Interval</MenuItem>
                                    <MenuItem value="r">Repitition</MenuItem>
                                  </Select>

                                  <Select
                                    id="select-option"
                                    variant="outlined"
                                    size="small"
                                    name="pace_type"
                                    value={item?.pace_type}
                                    label="Weight Type"
                                    inputProps={{
                                      style: {
                                        padding: 0,
                                      },
                                    }}
                                    onChange={(e) => {
                                      handleChangeVdotPaceType(
                                        e,
                                        index,
                                        exerIndex,
                                        setIndex,
                                      );
                                    }}
                                    sx={inputSx2}
                                  >
                                    {item?.optionsType?.map((option) => {
                                      return (
                                        <MenuItem
                                          key={option?.key}
                                          value={option?.key}
                                        >
                                          {option?.title}
                                        </MenuItem>
                                      );
                                    })}
                                  </Select>
                                </InputAdornment>
                              ),
                            }}
                            sx={{
                              borderRadius: "5px",
                              fontSize: "13px",
                              marginTop: "5px",
                              "& .css-e9crry-MuiInputBase-input-MuiOutlinedInput-input":
                                {
                                  width: "0px !important",
                                  padding: "9px 0px !important",
                                },
                              "& .css-1nuss9t": {
                                width: "0px !important",
                                padding: "9px 0px !important",
                              },
                              width: "100%",
                            }}
                          />
                        </div>
                        {exerData.parameters.includes("Distance") && (
                          <div className={class_name_1}>
                            <TextField
                              sx={{
                                borderRadius: "5px",
                                paddingRight: 0,
                                width: "100%",
                              }}
                              size="small"
                              id="custom-input"
                              variant="outlined"
                              placeholder={"Distance"}
                              name="distance"
                              label="Distance"
                              value={item?.distance}
                              onChange={(e) => {
                                handleChangeEmomSet(
                                  e,
                                  index,
                                  exerIndex,
                                  setIndex,
                                );
                              }}
                              type="number"
                              InputLabelProps={{
                                className: "textfiels-input-label",
                                shrink: true,
                                style: {
                                  fontSize: "14px",
                                },
                              }}
                              InputProps={{
                                className: "textfiels-input-value",
                                style: {
                                  fontSize: "13px",
                                  paddingRight: 0,
                                },
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <Select
                                      id="select-option"
                                      variant="outlined"
                                      size="small"
                                      name="distanceType"
                                      value={item?.distanceType}
                                      label="Weight Type"
                                      onChange={(e) => {
                                        handleChangeEmomSet(
                                          e,
                                          index,
                                          exerIndex,
                                          setIndex,
                                        );
                                      }}
                                      sx={{
                                        "& legend": {
                                          display: "none",
                                        },
                                        "& fieldset": {
                                          top: 0,
                                        },
                                        fontSize: "13px",
                                        border: "none",
                                        "& fieldset": {
                                          border: "none",
                                        },
                                      }}
                                    >
                                      <MenuItem value="m">Meter</MenuItem>
                                      <MenuItem value="km">KM</MenuItem>
                                      <MenuItem value="mi">Mile</MenuItem>
                                    </Select>
                                  </InputAdornment>
                                ),
                              }}
                            />
                          </div>
                        )}
                        {memberId ? (
                          item?.race_type == "el" ? (
                            <div
                              className={
                                isWithHistoryAndBigScreen
                                  ? "col-3 pe-0 py-1"
                                  : `col-12 col-md-3 col-lg-2 pe-0 py-1`
                              }
                            >
                              <TextField
                                id="outlined-basic"
                                variant="outlined"
                                label={getPaceText(item?.pace_type)}
                                InputLabelProps={{
                                  className: "textfiels-input-label",
                                  shrink: true,
                                  style: {
                                    fontSize: "14px",
                                  },
                                }}
                                InputProps={{
                                  className: "textfiels-input-value",
                                  style: {
                                    fontSize: "13px",
                                    paddingLeft: "0px",
                                    paddingRight: "0px",
                                    justifyContent: "center",
                                  },
                                  readOnly: true,
                                  endAdornment: (
                                    <InputAdornment
                                      position="end"
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <TextField
                                        id="outlined-basic-minutes"
                                        type="number"
                                        size="small"
                                        placeholder="Min"
                                        name="pace"
                                        value={formatWithLeadingZeros(
                                          Math.floor(item?.pace / 60),
                                        )}
                                        onChange={(e) =>
                                          handleMinutesChange(
                                            e,
                                            index,
                                            exerIndex,
                                            setIndex,
                                          )
                                        }
                                        InputProps={{
                                          className: "textfiels-input-value",
                                          style: {
                                            fontSize: "14px",
                                          },
                                          readOnly: true,
                                        }}
                                        sx={{
                                          "& fieldset": {
                                            border: "none",
                                          },
                                          "& input": {
                                            textAlign: "center",
                                            padding: "0px",
                                          },
                                          width: "100%",
                                        }}
                                      />
                                      <div className="fs-6 fw-semibold ms-1 ">
                                        :
                                      </div>
                                      <TextField
                                        id="outlined-basic-seconds"
                                        type="number"
                                        size="small"
                                        placeholder="Sec"
                                        name="pace"
                                        value={formatWithLeadingZeros(
                                          item?.pace % 60,
                                        )}
                                        onChange={(e) =>
                                          handleSecondsChange(
                                            e,
                                            index,
                                            exerIndex,
                                            setIndex,
                                          )
                                        }
                                        InputProps={{
                                          className: "textfiels-input-value",
                                          style: {
                                            fontSize: "14px",
                                          },
                                          readOnly: true,
                                        }}
                                        sx={{
                                          "& fieldset": {
                                            border: "none",
                                          },
                                          "& input": {
                                            textAlign: "center",
                                            padding: "0px",
                                          },
                                          width: "100%",
                                        }}
                                      />
                                      <div className="fs-6 fw-semibold ms-1 me-1 ">
                                        -
                                      </div>
                                      <TextField
                                        id="outlined-basic-minutes"
                                        type="number"
                                        size="small"
                                        placeholder="Min"
                                        name="paceUp"
                                        value={formatWithLeadingZeros(
                                          Math.floor(item?.paceUp / 60),
                                        )}
                                        onChange={(e) =>
                                          handleMinutesChange(
                                            e,
                                            index,
                                            exerIndex,
                                            setIndex,
                                          )
                                        }
                                        InputProps={{
                                          className: "textfiels-input-value",
                                          style: {
                                            fontSize: "14px",
                                          },
                                          readOnly: true,
                                        }}
                                        sx={{
                                          "& fieldset": {
                                            border: "none",
                                          },
                                          "& input": {
                                            textAlign: "center",
                                            padding: "0px",
                                          },
                                          width: "100%",
                                        }}
                                      />
                                      <div className="fs-6 fw-semibold ms-1">
                                        :
                                      </div>
                                      <TextField
                                        id="outlined-basic-seconds"
                                        type="number"
                                        size="small"
                                        placeholder="Sec"
                                        name="paceUp"
                                        value={formatWithLeadingZeros(
                                          item?.paceUp % 60,
                                        )}
                                        onChange={(e) =>
                                          handleSecondsChange(
                                            e,
                                            index,
                                            exerIndex,
                                            setIndex,
                                          )
                                        }
                                        InputProps={{
                                          className: "textfiels-input-value",
                                          style: {
                                            fontSize: "14px",
                                          },
                                          readOnly: true,
                                        }}
                                        sx={{
                                          "& fieldset": {
                                            border: "none",
                                          },
                                          "& input": {
                                            textAlign: "center",
                                            padding: "0px",
                                          },
                                          width: "100%",
                                          marginRight: 1,
                                        }}
                                      />
                                    </InputAdornment>
                                  ),
                                }}
                                sx={{
                                  borderRadius: "5px",
                                  fontSize: "13px",
                                  marginTop: "5px",
                                  "& .css-e9crry-MuiInputBase-input-MuiOutlinedInput-input":
                                    {
                                      width: "0px !important",
                                      padding: "9px 0px !important",
                                    },
                                  "& .css-1nuss9t": {
                                    width: "0px !important",
                                    padding: "9px 0px !important",
                                  },

                                  width: "100%",
                                }}
                              />
                            </div>
                          ) : (
                            <div
                              className={
                                isWithHistoryAndBigScreen
                                  ? "col-2 pe-0 py-1"
                                  : `col-12 col-md-2 col-lg-1 pe-0 py-1`
                              }
                            >
                              <TextField
                                id="outlined-basic"
                                variant="outlined"
                                label={getPaceText(item?.pace_type)}
                                InputLabelProps={{
                                  className: "textfiels-input-label",
                                  shrink: true,
                                  style: {
                                    fontSize: "14px",
                                  },
                                }}
                                InputProps={{
                                  className: "textfiels-input-value",
                                  style: {
                                    fontSize: "13px",
                                    paddingLeft: "0px",
                                    paddingRight: "0px",

                                    justifyContent: "center",
                                  },
                                  readOnly: true,
                                  endAdornment: (
                                    <InputAdornment
                                      position="end"
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <TextField
                                        id="outlined-basic-minutes"
                                        type="number"
                                        size="small"
                                        placeholder="Min"
                                        name="pace"
                                        value={formatWithLeadingZeros(
                                          Math.floor(item?.pace / 60),
                                        )}
                                        onChange={(e) =>
                                          handleMinutesChange(
                                            e,
                                            index,
                                            exerIndex,
                                            setIndex,
                                          )
                                        }
                                        InputProps={{
                                          className: "textfiels-input-value",
                                          style: {
                                            fontSize: "14px",
                                          },
                                          readOnly: true,
                                        }}
                                        sx={{
                                          "& fieldset": {
                                            border: "none",
                                          },
                                          "& input": {
                                            textAlign: "center",
                                            padding: "0px",
                                          },
                                          width: "100%",
                                        }}
                                      />
                                      <div className="fs-6 fw-semibold ms-1 ">
                                        :
                                      </div>
                                      <TextField
                                        id="outlined-basic-seconds"
                                        type="number"
                                        size="small"
                                        placeholder="Sec"
                                        name="pace"
                                        value={formatWithLeadingZeros(
                                          item?.pace % 60,
                                        )}
                                        onChange={(e) =>
                                          handleSecondsChange(
                                            e,
                                            index,
                                            exerIndex,
                                            setIndex,
                                          )
                                        }
                                        InputProps={{
                                          className: "textfiels-input-value",
                                          style: {
                                            fontSize: "14px",
                                          },
                                          readOnly: true,
                                        }}
                                        sx={{
                                          "& fieldset": {
                                            border: "none",
                                          },
                                          "& input": {
                                            textAlign: "center",
                                            padding: "0px",
                                          },
                                          width: "100%",
                                        }}
                                      />
                                    </InputAdornment>
                                  ),
                                }}
                                sx={{
                                  borderRadius: "5px",
                                  fontSize: "13px",
                                  "& .css-e9crry-MuiInputBase-input-MuiOutlinedInput-input":
                                    {
                                      width: "0px !important",
                                      padding: "9px 0px !important",
                                    },
                                  "& .css-1nuss9t": {
                                    width: "0px !important",
                                    padding: "9px 0px !important",
                                  },
                                  width: "100%",
                                  marginTop: "5px",
                                }}
                              />
                            </div>
                          )
                        ) : (
                          ""
                        )}
                      </>
                    )}
                    {exerData.parameters.includes("Pace") && (
                      <>
                        <div className={class_name_1}>
                          <FormControl fullWidth>
                            <InputLabel
                              className="set-Type-lable"
                              sx={{
                                fontSize: "14px",
                              }}
                              id="demo-simple-select-label"
                            >
                              Type
                            </InputLabel>
                            <Select
                              className="set-Type-value"
                              id="select-option"
                              variant="outlined"
                              size="small"
                              name="race_type"
                              value={item?.race_type}
                              label="Type"
                              inputProps={{
                                style: {
                                  padding: 0,
                                },
                              }}
                              onChange={(e) => {
                                handleChangeEmomSet(
                                  e,
                                  index,
                                  exerIndex,
                                  setIndex,
                                );
                              }}
                              sx={{
                                width: "100%",
                                fontSize: "13px",
                                "& .MuiOutlinedInput-input": {
                                  paddingLeft: 1,
                                },
                              }}
                            >
                              <MenuItem value="el">Easy/Long</MenuItem>
                              <MenuItem value="c">Compromised</MenuItem>
                              <MenuItem value="i">Interval</MenuItem>
                              <MenuItem value="r">Repitition</MenuItem>
                            </Select>
                          </FormControl>
                        </div>
                        <div className={class_name_1}>
                          <TextField
                            sx={{
                              borderRadius: "5px",
                              paddingRight: 0,
                              width: "100%",
                            }}
                            size="small"
                            id="custom-input"
                            variant="outlined"
                            placeholder={"Distance"}
                            name="distance"
                            label="Distance"
                            value={item?.distance}
                            onChange={(e) => {
                              handleChangeEmomSet(
                                e,
                                index,
                                exerIndex,
                                setIndex,
                              );
                            }}
                            type="number"
                            InputLabelProps={{
                              className: "textfiels-input-label",
                              shrink: true,
                              style: {
                                fontSize: "14px",
                              },
                            }}
                            InputProps={{
                              className: "textfiels-input-value",
                              style: {
                                fontSize: "13px",
                                paddingRight: 0,
                              },
                              endAdornment: (
                                <InputAdornment position="end">
                                  <Select
                                    id="select-option"
                                    variant="outlined"
                                    size="small"
                                    name="distanceType"
                                    value={item?.distanceType}
                                    label="Weight Type"
                                    onChange={(e) => {
                                      handleChangeEmomSet(
                                        e,
                                        index,
                                        exerIndex,
                                        setIndex,
                                      );
                                    }}
                                    sx={{
                                      "& legend": {
                                        display: "none",
                                      },
                                      "& fieldset": {
                                        top: 0,
                                      },
                                      fontSize: "13px",
                                      border: "none",
                                      "& fieldset": {
                                        border: "none",
                                      },
                                    }}
                                  >
                                    <MenuItem value="m">Meter</MenuItem>
                                    <MenuItem value="km">KM</MenuItem>
                                    <MenuItem value="mi">Mile</MenuItem>
                                  </Select>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </div>
                        <div
                          className={
                            isWithHistoryAndBigScreen
                              ? "col-3 pe-0 py-2"
                              : `col-12 col-md-2 col-lg-2 pe-0 py-2`
                          }
                        >
                          <TextField
                            id="outlined-basic"
                            variant="outlined"
                            label={getPaceTextinPaces(item?.distanceType)}
                            InputLabelProps={{
                              className: "textfiels-input-label",
                              shrink: true,
                              style: {
                                fontSize: "14px",
                              },
                            }}
                            InputProps={{
                              className: "textfiels-input-value",
                              style: {
                                fontSize: "13px",
                                paddingLeft: "0px",
                                paddingRight: "0px",

                                justifyContent: "center",
                              },
                              readOnly: true,
                              endAdornment: (
                                <InputAdornment
                                  position="end"
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <TextField
                                    id="outlined-basic-minutes"
                                    type="number"
                                    size="small"
                                    placeholder="Min"
                                    name="pace"
                                    value={formatWithLeadingZeros(
                                      Math.floor(item?.pace / 60),
                                    )}
                                    onChange={(e) =>
                                      handleMinutesChangeSets(
                                        e,
                                        index,
                                        exerIndex,
                                        setIndex,
                                      )
                                    }
                                    InputProps={{
                                      className: "textfiels-input-value",
                                      style: {
                                        fontSize: "14px",
                                      },
                                    }}
                                    sx={{
                                      "& fieldset": {
                                        border: "none",
                                      },
                                      "& input": {
                                        textAlign: "center",
                                        padding: "0px",
                                      },
                                      width: "100%",
                                    }}
                                  />
                                  <div className="fs-6 fw-semibold ms-1 ">
                                    :
                                  </div>

                                  <TextField
                                    id="outlined-basic-seconds"
                                    type="number"
                                    size="small"
                                    placeholder="Sec"
                                    name="pace"
                                    value={formatWithLeadingZeros(
                                      item?.pace % 60,
                                    )}
                                    onChange={(e) =>
                                      handleSecondsChangeSets(
                                        e,
                                        index,
                                        exerIndex,
                                        setIndex,
                                      )
                                    }
                                    InputProps={{
                                      className: "textfiels-input-value",
                                      style: {
                                        fontSize: "14px",
                                      },
                                    }}
                                    sx={{
                                      "& fieldset": {
                                        border: "none",
                                      },
                                      "& input": {
                                        textAlign: "center",
                                        padding: "0px",
                                      },
                                      width: "100%",
                                    }}
                                  />
                                </InputAdornment>
                              ),
                            }}
                            sx={{
                              borderRadius: "5px",
                              fontSize: "13px",
                              "& .css-e9crry-MuiInputBase-input-MuiOutlinedInput-input":
                                {
                                  width: "0px !important",
                                  padding: "9px 0px !important",
                                },
                              "& .css-1nuss9t": {
                                width: "0px !important",
                                padding: "9px 0px !important",
                              },
                              width: "100%",
                            }}
                          />
                        </div>
                        <div
                          style={{
                            position: "absolute",
                            bottom: "4px",
                            left: "5px",
                          }}
                        >
                          <Typography
                            variant="subtitle2"
                            sx={{
                              opacity: 0.6,
                              fontWeight: "600",
                              fontSize: "12px",
                            }}
                          >{` @ Speed ${getKmhrForPace(
                            item?.distance,
                            item?.pace,
                            item?.distanceType,
                          )} km/hr or ${getMihrForPace(
                            item?.distance,
                            item?.pace,
                            item?.distanceType,
                          )} mi/hr`}</Typography>
                        </div>
                      </>
                    )}
                    {(exerData.parameters.includes("Duration/Pace") ||
                      exerData.parameters.includes("Time")) && (
                      <div className={class_name_1}>
                        <TextField
                          id="outlined-basic"
                          size="small"
                          variant="outlined"
                          placeholder="0"
                          type="number"
                          value={item?.time}
                          name="time"
                          onChange={(e) => {
                            handleChangeEmomSet(e, index, exerIndex, setIndex);
                          }}
                          InputLabelProps={{
                            className: "textfiels-input-label",
                            shrink: true,
                            style: {
                              fontSize: "14px",
                            },
                          }}
                          label={
                            exerData.parameters.includes("Duration/Pace")
                              ? "Duration/Pace"
                              : "Time"
                          }
                          InputProps={{
                            className: "textfiels-input-value",
                            style: {
                              fontSize: "13px",
                              paddingRight: 0,
                            },
                            endAdornment: (
                              <InputAdornment position="end">
                                <Select
                                  id="select-option"
                                  variant="outlined"
                                  size="small"
                                  name="timeType"
                                  value={item?.timeType}
                                  label="Weight Type"
                                  inputProps={{
                                    style: {
                                      padding: 0,
                                    },
                                  }}
                                  onChange={(e) => {
                                    handleChangeEmomSet(
                                      e,
                                      index,
                                      exerIndex,
                                      setIndex,
                                    );
                                  }}
                                  sx={inputSx}
                                >
                                  <MenuItem value="sec">sec</MenuItem>
                                  <MenuItem value="min">min</MenuItem>
                                </Select>
                              </InputAdornment>
                            ),
                          }}
                          sx={{
                            borderRadius: "5px",
                            fontSize: "13px",
                            width: "100%",
                          }}
                        />
                      </div>
                    )}
                    {!reps_for_time && exerData.parameters.includes("Reps") ? (
                      <div className={class_name}>
                        <TextField
                          id="outlined-basic"
                          size="small"
                          variant="outlined"
                          placeholder="Reps"
                          type="text"
                          label="Reps"
                          value={item?.reps}
                          name="reps"
                          onChange={(e) => {
                            handleChangeEmomSet(e, index, exerIndex, setIndex);
                          }}
                          InputLabelProps={{
                            className: "textfiels-input-label",
                            shrink: true,
                            style: {
                              fontSize: "14px",
                            },
                          }}
                          InputProps={{
                            className: "textfiels-input-value",
                            style: {
                              fontSize: "13px",
                            },
                          }}
                          sx={{
                            borderRadius: "5px",
                            fontSize: "13px",
                            width: "100%",
                          }}
                        />
                      </div>
                    ) : (
                      ""
                    )}
                    {!reps_for_time &&
                    exerData.parameters.includes("Max_Reps") ? (
                      <div className={class_name}>
                        <TextField
                          id="outlined-basic"
                          size="small"
                          variant="outlined"
                          placeholder="Max Reps"
                          type="number"
                          label="Max Reps"
                          value={item?.maxReps}
                          name="maxReps"
                          onChange={(e) => {
                            handleChangeEmomSet(e, index, exerIndex, setIndex);
                          }}
                          InputLabelProps={{
                            className: "textfiels-input-label",
                            shrink: true,
                            style: {
                              fontSize: "14px",
                            },
                          }}
                          InputProps={{
                            className: "textfiels-input-value",
                            style: {
                              fontSize: "13px",
                            },
                          }}
                          sx={{
                            borderRadius: "5px",
                            fontSize: "13px",
                            width: "100%",
                          }}
                        />
                      </div>
                    ) : (
                      ""
                    )}
                    {exerData.parameters.includes("Watts") && (
                      <div className={class_name}>
                        <TextField
                          id="outlined-basic"
                          size="small"
                          variant="outlined"
                          placeholder="Watts"
                          type="number"
                          label="Watts"
                          value={item?.watts}
                          name="watts"
                          onChange={(e) => {
                            handleChangeEmomSet(e, index, exerIndex, setIndex);
                          }}
                          InputLabelProps={{
                            className: "textfiels-input-label",
                            shrink: true,
                            style: {
                              fontSize: "14px",
                            },
                          }}
                          InputProps={{
                            className: "textfiels-input-value",
                            style: {
                              fontSize: "13px",
                            },
                          }}
                          sx={{
                            borderRadius: "5px",
                            fontSize: "13px",
                            width: "100%",
                          }}
                        />
                      </div>
                    )}
                    {exerData.parameters.includes("Height") && (
                      <div className={class_name_1}>
                        <TextField
                          id="outlined-basic"
                          size="small"
                          variant="outlined"
                          placeholder="0"
                          type="number"
                          value={item?.height}
                          name="height"
                          onChange={(e) => {
                            handleChangeEmomSet(e, index, exerIndex, setIndex);
                          }}
                          InputLabelProps={{
                            className: "textfiels-input-label",
                            shrink: true,
                            style: {
                              fontSize: "14px",
                            },
                          }}
                          label="Height"
                          InputProps={{
                            className: "textfiels-input-value",
                            style: {
                              fontSize: "13px",
                              paddingRight: 0,
                            },
                            endAdornment: (
                              <InputAdornment position="end">
                                <Select
                                  id="select-option"
                                  variant="outlined"
                                  size="small"
                                  name="height_unit"
                                  value={item?.height_unit}
                                  label="Weight Type"
                                  inputProps={{
                                    style: {
                                      padding: 0,
                                    },
                                  }}
                                  onChange={(e) => {
                                    handleChangeEmomSet(
                                      e,
                                      index,
                                      exerIndex,
                                      setIndex,
                                    );
                                  }}
                                  sx={inputSx}
                                >
                                  <MenuItem value="cm">Cm</MenuItem>
                                  <MenuItem value="ft">Feet</MenuItem>
                                  <MenuItem value="inch">Inch</MenuItem>
                                </Select>
                              </InputAdornment>
                            ),
                          }}
                          sx={{
                            borderRadius: "5px",
                            fontSize: "13px",
                            width: "100%",
                          }}
                        />
                      </div>
                    )}
                    {exerData.parameters.includes("Weight") && (
                      <div
                        className={
                          isWithHistoryAndBigScreen
                            ? "col-3 pe-0 py-2"
                            : "col-12 col-md-4 col-lg-2 pe-0 py-2"
                        }
                      >
                        <TextField
                          sx={{
                            borderRadius: "5px",
                            paddingRight: 0,
                            width: "100%",
                          }}
                          size="small"
                          id="custom-input"
                          variant="outlined"
                          placeholder="Weight"
                          name="weight"
                          label="Weight"
                          value={item.weight}
                          onChange={(e) => {
                            handleChangeEmomSet(e, index, exerIndex, setIndex);
                          }}
                          type="number"
                          InputLabelProps={{
                            className: "textfiels-input-label",
                            shrink: true,
                            style: {
                              fontSize: "14px",
                            },
                          }}
                          InputProps={{
                            className: "textfiels-input-value",
                            style: {
                              fontSize: "13px",
                              paddingRight: 0,
                            },
                            endAdornment: (
                              <InputAdornment position="end">
                                <Select
                                  id="select-option"
                                  variant="outlined"
                                  size="small"
                                  name="weightType"
                                  value={item?.weightType}
                                  label="Weight Type"
                                  onChange={(e) => {
                                    handleChangeEmomSet(
                                      e,
                                      index,
                                      exerIndex,
                                      setIndex,
                                    );
                                  }}
                                  sx={inputSx}
                                >
                                  <MenuItem value="1rm">% 1RM</MenuItem>
                                  <MenuItem value="body_weight">% BW</MenuItem>
                                  <MenuItem value="kg">KG</MenuItem>
                                  <MenuItem value="lb">Pound</MenuItem>
                                  <MenuItem value="poods">Poods</MenuItem>
                                </Select>
                              </InputAdornment>
                            ),
                          }}
                        />
                      </div>
                    )}
                    {exerData.parameters.includes("Distance/Calories") && (
                      <div className={class_name_1}>
                        <TextField
                          sx={{
                            borderRadius: "5px",
                            paddingRight: 0,
                            width: "100%",
                          }}
                          size="small"
                          id="custom-input"
                          variant="outlined"
                          placeholder={
                            item?.distanceType == "calories"
                              ? "Calories"
                              : "Distance"
                          }
                          name="distance"
                          label="Distance/Calories"
                          value={item?.distance}
                          onChange={(e) => {
                            handleChangeEmomSet(e, index, exerIndex, setIndex);
                          }}
                          type="number"
                          InputLabelProps={{
                            className: "textfiels-input-label",
                            shrink: true,
                            style: {
                              fontSize: "14px",
                            },
                          }}
                          InputProps={{
                            className: "textfiels-input-value",
                            style: {
                              fontSize: "13px",
                              paddingRight: 0,
                            },
                            endAdornment: (
                              <InputAdornment position="end">
                                <Select
                                  id="select-option"
                                  variant="outlined"
                                  size="small"
                                  name="distanceType"
                                  value={item?.distanceType}
                                  label="Weight Type"
                                  onChange={(e) => {
                                    handleChangeEmomSet(
                                      e,
                                      index,
                                      exerIndex,
                                      setIndex,
                                    );
                                  }}
                                  sx={inputSx}
                                >
                                  <MenuItem value="m">Meter</MenuItem>
                                  <MenuItem value="km">KM</MenuItem>
                                  <MenuItem value="mi">Mile</MenuItem>
                                  <MenuItem value="calories">Calories</MenuItem>
                                </Select>
                              </InputAdornment>
                            ),
                          }}
                        />
                      </div>
                    )}
                    {exerData.parameters.includes("%MHR") && (
                      <div className={class_name}>
                        <TextField
                          id="outlined-basic"
                          size="small"
                          variant="outlined"
                          placeholder="%MHR"
                          type="number"
                          label="%MHR"
                          value={item?.mhr}
                          name="mhr"
                          onChange={(e) => {
                            handleChangeEmomSetTempo(
                              e,
                              index,
                              exerIndex,
                              setIndex,
                            );
                          }}
                          InputLabelProps={{
                            className: "textfiels-input-label",
                            shrink: true,
                            style: {
                              fontSize: "14px",
                            },
                          }}
                          InputProps={{
                            className: "textfiels-input-value",
                            style: {
                              fontSize: "13px",
                            },
                          }}
                          sx={{
                            borderRadius: "5px",

                            fontSize: "13px",
                            width: "100%",
                            "& .MuiOutlinedInput-input": {
                              padding: "8px 7px",
                            },
                          }}
                        />
                      </div>
                    )}{" "}
                    {exerData.parameters.includes("RPE") && (
                      <div className={class_name}>
                        <TextField
                          id="outlined-basic"
                          size="small"
                          variant="outlined"
                          placeholder="RPE"
                          label="RPE"
                          value={item?.RPE}
                          name="RPE"
                          onChange={(e) => {
                            handleChangeEmomSet(e, index, exerIndex, setIndex);
                          }}
                          InputLabelProps={{
                            className: "textfiels-input-label",
                            shrink: true,
                            style: {
                              fontSize: "14px",
                            },
                          }}
                          InputProps={{
                            className: "textfiels-input-value",
                            style: {
                              fontSize: "13px",
                            },
                          }}
                          sx={{
                            borderRadius: "5px",

                            fontSize: "13px",
                            width: "100%",
                            "& .MuiOutlinedInput-input": {
                              padding: "8px 7px",
                            },
                          }}
                        />
                      </div>
                    )}
                    {exerData.parameters.includes("Tempo") && (
                      <div className={class_name}>
                        <TextField
                          id="outlined-basic"
                          size="small"
                          variant="outlined"
                          placeholder="Tempo"
                          type="number"
                          label="Tempo"
                          value={item?.tempo}
                          name="tempo"
                          onChange={(e) => {
                            handleChangeEmomSetTempo(
                              e,
                              index,
                              exerIndex,
                              setIndex,
                            );
                          }}
                          InputLabelProps={{
                            className: "textfiels-input-label",
                            shrink: true,
                            style: {
                              fontSize: "14px",
                            },
                          }}
                          InputProps={{
                            className: "textfiels-input-value",
                            style: {
                              fontSize: "13px",
                            },
                          }}
                          sx={{
                            borderRadius: "5px",
                            fontSize: "13px",
                            width: "100%",
                            "& .MuiOutlinedInput-input": {
                              padding: "8px 7px",
                            },
                          }}
                        />
                      </div>
                    )}
                    {exerData.parameters.includes("Rest") && (
                      <div className={class_name_1}>
                        <TextField
                          id="outlined-basic"
                          size="small"
                          variant="outlined"
                          placeholder="0"
                          type="number"
                          value={item?.rest}
                          name="rest"
                          onChange={(e) => {
                            handleChangeEmomSet(e, index, exerIndex, setIndex);
                          }}
                          InputLabelProps={{
                            className: "textfiels-input-label",
                            shrink: true,
                            style: {
                              fontSize: "14px",
                            },
                          }}
                          label="Rest"
                          InputProps={{
                            className: "textfiels-input-value",
                            style: {
                              fontSize: "13px",
                              paddingRight: 0,
                            },
                            endAdornment: (
                              <InputAdornment position="end">
                                <Select
                                  id="select-option"
                                  variant="outlined"
                                  size="small"
                                  name="restType"
                                  value={item?.restType}
                                  label="Weight Type"
                                  inputProps={{
                                    style: {
                                      padding: 0,
                                    },
                                  }}
                                  onChange={(e) => {
                                    handleChangeEmomSet(
                                      e,
                                      index,
                                      exerIndex,
                                      setIndex,
                                    );
                                  }}
                                  sx={inputSx}
                                >
                                  <MenuItem value="sec">sec</MenuItem>
                                  <MenuItem value="min">min</MenuItem>
                                </Select>
                              </InputAdornment>
                            ),
                          }}
                          sx={{
                            borderRadius: "5px",
                            fontSize: "13px",
                            width: "100%",
                          }}
                        />
                      </div>
                    )}
                    {memberId && exerData.parameters.includes("Vdot") && (
                      <div>
                        {item?.race_type == "el" ? (
                          <Typography
                            variant="subtitle2"
                            sx={{
                              opacity: 0.6,
                              fontWeight: "600",
                              fontSize: "12px",
                            }}
                          >{` @ Speed ${getKmhr(
                            item?.pace,
                            item?.pace_type,
                          )} km/hr or ${getMihr(
                            item?.pace,
                            item?.pace_type,
                          )} mi/hr -  ${getKmhr(
                            item?.paceUp,
                            item?.pace_type,
                          )} km/hr or ${getMihr(
                            item?.paceUp,
                            item?.pace_type,
                          )} mi/hr`}</Typography>
                        ) : (
                          <Typography
                            variant="subtitle2"
                            sx={{
                              opacity: 0.6,
                              fontWeight: "600",
                              fontSize: "12px",
                            }}
                          >{` @ Speed ${getKmhr(
                            item?.pace,
                            item?.pace_type,
                          )} km/hr or ${getMihr(
                            item?.pace,
                            item?.pace_type,
                          )} mi/hr`}</Typography>
                        )}
                      </div>
                    )}
                  </div>
                )}
              </div>
            ))}
        </Box>
      </div>
    </div>
  );
};

export default CustomFeilds;
